// extracted by mini-css-extract-plugin
module.exports = {"root":"_ba43ed"};